export { default } from "./MTLogo";
